import { Check } from "lucide-react";

const WhatYouGet: React.FC = () => {
  const features = [
    "Next.js 14 High-Conversion Landing Page",
    "Anti-Troll & Gibberish Filtering System",
    "Prisma Schema & PostgreSQL Database setup",
    "Dynamic Referral Tracking (?ref=source)",
    "Honeypot Bot Protection",
    "Clean TypeScript Architecture",
    "Responsive UI with Tailwind CSS",
    "Premium AI Prompts for Mockups & Visuals",
    "Vercel Deployment Ready configuration",
    "Lifetime Access to the Source Code"
  ];

  return (
    <section className="bg-[#050505] text-white pt-20 pb-8 px-4 border-t border-white/5">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-5xl font-black mb-4 text-center tracking-tight">
          No fluff. Just what you need.
        </h2>

        <p className="text-lg md:text-xl text-gray-400 mb-12 text-center max-w-2xl mx-auto">
          A lean, fast, and secure boilerplate designed to do one thing: <span className="text-cyan-400">capture leads effectively.</span>
        </p>

        <div className="grid md:grid-cols-2 gap-3 mb-12">
          {features.map((item, index) => (
            <div key={index} className="flex items-center space-x-3 bg-white/5 border border-white/10 p-4 rounded-xl hover:bg-white/[0.08] transition-colors">
              <div className="bg-cyan-400/20 p-1 rounded-full">
                <Check className="text-cyan-400 flex-shrink-0" size={16} />
              </div>
              <span className="text-gray-200 sm:text-lg text-sm">{item}</span>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white/5 border border-white/10 p-6 md:p-8 rounded-2xl relative overflow-hidden group">
          {/* Decoración sutil de fondo */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-400/5 blur-3xl -z-10"></div>

          <div className="flex flex-col md:flex-row items-center gap-6">
            {/* Tu Imagen */}
            <div className="flex-shrink-0">
              <img
                src="/images/eliana-boat-3.png"
                alt="Eliana Jordan"
                className="w-20 h-20 md:w-28 md:h-28 object-cover rounded-full border-2 border-cyan-400 shadow-[0_0_20px_rgba(34,211,238,0.3)] group-hover:scale-105 transition-transform duration-500"
              />
            </div>

            {/* El Texto */}
            <div className="text-center md:text-left">
              <p className="text-gray-200 italic text-lg md:text-xl leading-relaxed mb-4">
                "I used this exact boilerplate to launch Cestio and got <span className="text-cyan-400 font-bold">50+ signups in just 9 days</span>. Waitlists are the ultimate cheat code—they let you build a hungry audience while you're still coding your MVP."
              </p>

              <div>
                <p className="text-cyan-400 font-bold text-base md:text-lg">Eliana Jordan</p>
                <p className="text-gray-500 text-sm uppercase tracking-widest font-medium">Founder of Cestio</p>
              </div>
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-lg text-gray-300 font-medium">
          This is a production-ready boilerplate. Get your joinlist up and running in 10 minutes, not weeks.
        </p>
      </div>
    </section>
  );
};

export default WhatYouGet;